var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverVerticleStrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "METAL-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.01 67.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-14,.cls-18,.cls-19,.cls-2,.cls-20,.cls-27,.cls-28,.cls-6,.cls-7,.cls-8{opacity:0.59;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#Sky_12);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#radial-gradient-2);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:url(#Sky_12-2);}.cls-18{fill:url(#linear-gradient-13);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#radial-gradient-3);}.cls-25{fill:url(#radial-gradient-4);}.cls-26{fill:url(#Sky_12-3);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:#e5e1d8;}.cls-30{fill:#d9d5d2;}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 8,
    cy: 37.59,
    r: 9.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f3f3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d7dade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#dcd9d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.41,
    y1: 48.31,
    x2: 15.41,
    y2: 26.88,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b869f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7b869f",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7b869f",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#7b869f",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7b869f",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7b869f",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7b869f",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7b869f",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#7b869f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.57,
    y1: 42.16,
    x2: 15.79,
    y2: 26.94,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a8b5",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fffbe7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fffbe7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fffbe7",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fffbe7",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fffbe7",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbe7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.67,
    y1: 49.34,
    x2: 0.67,
    y2: 41.98,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffbe7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbe7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky_12",
    x1: 2.52,
    y1: 40.78,
    x2: 13.41,
    y2: 40.78,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5adc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7b87a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2.6,
    y1: 45.82,
    x2: 3.63,
    y2: 45.82,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5d6881",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5a657d",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#566076",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 260.87,
    y1: -118.28,
    x2: 261.67,
    y2: -118.28,
    gradientTransform: "matrix(-0.69, 0.72, 0.72, 0.69, 274.16, -51.34)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 12.25,
    y1: 40.78,
    x2: 13.43,
    y2: 40.78,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 141.02,
    y1: 453.62,
    x2: 141.02,
    y2: 452.28,
    gradientTransform: "translate(464.51 -88.5) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 201.73,
    y1: -146.73,
    x2: 201.73,
    y2: -148.06,
    gradientTransform: "translate(151.77 250.23) rotate(-90)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 8.97,
    y1: -10.06,
    x2: 7.85,
    y2: -11.18,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 43.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 8,
    cy: 10.72,
    r: 9.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 15.41,
    y1: 21.44,
    x2: 15.41,
    y2: 0.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.57,
    y1: 15.29,
    x2: 15.79,
    y2: 0.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.67,
    y1: 25.87,
    x2: 0.67,
    y2: 15.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fffbe7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbe7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky_12-2",
    x1: 2.52,
    y1: 13.91,
    x2: 13.41,
    y2: 13.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Sky_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2.55,
    y1: 18.95,
    x2: 3.74,
    y2: 18.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#545e74",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 280.3,
    y1: -99.73,
    x2: 281.11,
    y2: -99.73,
    gradientTransform: "translate(274.16 145.97) rotate(-133.65)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 12.28,
    y1: 13.91,
    x2: 13.43,
    y2: 13.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 116.92,
    y1: 453.62,
    x2: 116.92,
    y2: 452.25,
    gradientTransform: "matrix(0, -1, -1, 0, 464.51, 132.15)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 225.84,
    y1: -146.7,
    x2: 225.84,
    y2: -148.03,
    gradientTransform: "matrix(0, 1, 1, 0, 151.77, -206.58)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 9.1,
    y1: 14.15,
    x2: 7.88,
    y2: 12.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 14.71,
    cy: 33.88,
    r: 8.85,
    gradientTransform: "translate(0 -0.62) scale(1 1.02)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -3.86,
    cy: 33.88,
    r: 8.85,
    gradientTransform: "translate(5 -0.62) scale(0.97 1.02)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky_12-3",
    x1: 2.52,
    y1: 33.88,
    x2: 13.41,
    y2: 33.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Sky_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 12.25,
    y1: 60.74,
    x2: 13.43,
    y2: 60.74,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2.55,
    y1: 60.74,
    x2: 3.65,
    y2: 60.74,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 94.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5d6881",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5a657d",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#566076",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 216.35,
    y1: -146.73,
    x2: 216.35,
    y2: -148.06,
    gradientTransform: "translate(151.77 250.23) rotate(-90)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 216.35,
    y1: 186.93,
    x2: 216.35,
    y2: 185.55,
    gradientTransform: "matrix(0, -1, -1, 0, 197.81, 250.23)",
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cost_Panel_v1",
    "data-name": "Cost Panel_v1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom_Frame",
    "data-name": "Bottom Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M0,46.31V53a.43.43,0,0,0,.14.32L15.26,67.63a.44.44,0,0,0,.75-.32v-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M16,67a1.21,1.21,0,0,1,0,.5,1.42,1.42,0,0,1-.19.18l-1-2.32V46.31H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M14.81,65.37,1.34,52.31,0,53s0,.21.07.26c.31.27.65.61.65.61l14,13.19a4.83,4.83,0,0,0,.66.6.39.39,0,0,0,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "1.34 52.31 0 53.03 0 46.31 1.34 46.31 1.34 52.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "2.52 46.31 2.54 51.29 13.41 61.38 13.41 46.31 2.52 46.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "3.71 46.31 3.71 50.68 2.54 51.29 2.52 46.31 3.71 46.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "13.4 61.38 2.53 51.29 3.71 50.68 12.23 58.73 13.4 61.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "12.23 46.31 12.23 58.73 13.41 61.38 13.41 46.31 12.27 46.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.23 46.31 12.23 58.73 3.71 50.68 3.71 46.31 12.23 46.31"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "10.89 55.63 10.89 46.31 12.23 46.31 12.23 58.73 10.89 55.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "5.04 46.31 5.04 49.89 3.71 50.68 3.71 46.31 5.04 46.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "12.23 58.73 3.71 50.68 5.04 49.89 10.89 55.63 12.23 58.73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top_Frame",
    "data-name": "Top Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-13",
    d: "M0,21.44V14.72a.43.43,0,0,1,.14-.32L15.26.12A.45.45,0,0,1,16,.45v21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-14",
    d: "M16,.74a1.16,1.16,0,0,0,0-.49,1,1,0,0,0-.19-.18l-1,2.32V21.44H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-15",
    d: "M14.81,2.39,1.34,15.44,0,14.72s0-.2.07-.26c.31-.27.65-.61.65-.61L14.68.67a4.25,4.25,0,0,1,.66-.6.39.39,0,0,1,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-16",
    points: "1.34 15.44 0 14.72 0 21.44 1.34 21.44 1.34 15.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-17",
    points: "2.52 21.44 2.54 16.47 13.41 6.37 13.41 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-18",
    points: "2.52 21.44 2.54 16.47 3.74 17.07 3.74 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-19",
    points: "13.41 6.37 2.53 16.47 3.73 17.07 12.26 9.02 13.41 6.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-20",
    points: "12.26 21.44 12.26 9.02 13.41 6.37 13.41 21.44 12.27 21.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.26 21.44 12.26 9.02 3.75 17.07 3.74 21.44 12.26 21.44"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-21",
    points: "10.9 12.35 10.88 21.44 12.26 21.44 12.26 9.02 10.9 12.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-22",
    points: "5.08 21.44 5.08 17.86 3.74 17.07 3.74 21.44 5.08 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "12.26 9.02 3.74 17.07 5.08 17.86 10.9 12.35 12.26 9.02"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-3",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 13.41,
    y: 21.21,
    width: 2.6,
    height: 25.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    y: 21.21,
    width: 2.52,
    height: 25.34
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M13.41,46.54V21.21m-10.89,0V46.55M13.41,21.21H12.26l0,17.46v7.88h1.18M3.74,21.21H2.52V46.55H3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-27",
    points: "13.41 21.21 13.41 46.55 12.23 46.55 12.26 21.21 13.41 21.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-28",
    points: "3.74 21.21 3.71 46.55 2.52 46.55 2.52 21.21 3.74 21.21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-29",
    y: 21.21,
    width: 1.34,
    height: 25.33
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-4",
    "data-name": "Left HL",
    className: "cls-30",
    x: 14.81,
    y: 21.21,
    width: 1.18,
    height: 25.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "12.26 21.21 3.74 21.21 3.71 46.55 12.23 46.55 12.26 21.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-31",
    points: "5.04 21.21 5.04 46.55 3.71 46.55 3.74 21.21 5.04 21.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-32",
    points: "10.88 21.21 10.88 46.55 12.23 46.55 12.26 21.21 10.88 21.21"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverVerticleStrip);
export default __webpack_public_path__ + "static/media/silverVerticleStrip.7e5a63dc42dee7104d8153a87268d770.svg";
export { ForwardRef as ReactComponent };